import { useEffect, useState } from "react";
import { prefersReducedMotion } from "../../lib/motion";

const LOADER_KEY = "manza-intro-seen";

const PageLoader = () => {
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") {
      return true;
    }

    return (
      !window.sessionStorage.getItem(LOADER_KEY) && !prefersReducedMotion()
    );
  });
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!visible) {
      return;
    }

    let cancelled = false;
    const minimumDisplay = new Promise((resolve) =>
      window.setTimeout(resolve, 720),
    );
    const fontsReady = document.fonts?.ready ?? Promise.resolve();

    Promise.all([minimumDisplay, fontsReady]).then(() => {
      if (cancelled) {
        return;
      }

      window.sessionStorage.setItem(LOADER_KEY, "true");
      setLeaving(true);
      window.setTimeout(() => setVisible(false), 480);
    });

    return () => {
      cancelled = true;
    };
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className={`page-loader${leaving ? " is-leaving" : ""}`}
      role="status"
      aria-live="polite"
      aria-label="Loading Manza portfolio"
    >
      <div className="page-loader__frame">
        <span className="page-loader__eyebrow">Portfolio - 2K26</span>
        <strong className="page-loader__word">MANZA</strong>
        <div className="page-loader__meta">
          <span>Software developer</span>
          <span className="page-loader__count" aria-hidden="true">
            000—100
          </span>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
